function Footer() {
  return (
    <footer
      style={{
         //backgroundColor:"#EB92A9",
       //backgroundColor: "#3a6fb6",
        backgroundColor: "#202D55",
     color: "white",
      // color:"black",
        textAlign: "center",
        padding: "15px 0",
        position: "fixed",
        bottom: 0,
        left: 0,
        width: "100%"
      }}
    >
      © 2026
    </footer>
  );
}

export default Footer;

